export default function ButtonEmailMacrosDialog (pButton)
{
  const pThis = this;
  pThis.isObjValid = false;

  pThis.init = init;
  pThis.getIsEnabled = getIsEnabled;
  pThis.stopSetBlur = stopSetBlur;
  pThis.getState = getState;
  pThis.click = click;

  let extParameters,
      currentWindow;

  let currentControl = null,
      isFocused = false,
      pDialog,
      saveCurrentRange = null,
      isSaveCurrentRange = false,
      checkSavedRangeTM = null,
      setBlurTM = null,
      sMacros;


  function init (ext, initExtParameters)
  {
    const controlsIds = ext.extentionControlsIds;

    let control;

    extParameters = initExtParameters;
    currentWindow = (BEditor.environment.topWindow.contentarea && BEditor.AdminPanel.getContentAreaType() !== "adminComponent") ? BEditor.environment.topWindow.contentarea : BEditor.environment.topWindow;

    for (let i = 0; i < controlsIds.length; i++)
    {
      control = BEditor.domHelpers.$(controlsIds[i], currentWindow);

      if (control)
      {
        control.onfocus = function ()
        {
          isFocused = true;
          currentControl = this;
          pButton.refreshState();

          if (BEditor.browser.isIE)
          {
            checkSavedRangeTM = setInterval(checkSavedRange, 37);
          }
        };

        control.onblur = setBlur;
      }
    }
  }


  function setBlur ()
  {
    if (BEditor.browser.isIE)
    {
      if (checkSavedRangeTM) clearInterval(checkSavedRangeTM);
    }

    if (setBlurTM) clearTimeout(setBlurTM);
    setBlurTM = setTimeout(setBlurDo, 10);
  }


  function stopSetBlur ()
  {
    if (setBlurTM) clearTimeout(setBlurTM);
  }


  function setBlurDo ()
  {
    isFocused = false;
    pButton.refreshState();
  }


  function checkSavedRange ()
  {
    isSaveCurrentRange = false;
    saveRange();
  }


  function getIsEnabled ()
  {
    return isFocused;
  }


  function getState ()
  {
    return false;
  }


  function click ()
  {
    pDialog = pButton.getDialog();

    if (!pDialog)
    {
      return false;
    }

    pDialog.setReturnedParameters('macrosJson', extParameters.macrosJson);
    pDialog.setReturnedParameters('macros', '');
    pDialog.openWindow(insert, close);

    setTimeout(pButton.refreshState, 10);
  }


  function insert (pButton)
  {
    let pParameters,
        currentSelection,
        currentRange;

    if (pDialog)
    {
      pParameters = pDialog.getReturnedParameters();
      sMacros = (pParameters) ? pParameters.macros : null;

      close();

      if (sMacros)
      {
        currentSelection = getCurrentSelection();
        currentRange = getCurrentRange();

        if (currentSelection && currentRange)
        {
          if (BEditor.browser.isIE)
          {
            currentRange.text = sMacros;
          }
          else
          {
            setTimeout(insertDo, 10);
          }
        }
      }
    }
  }


  function insertDo ()
  {
    const posBegin = currentControl.selectionStart,
          posEnd = currentControl.selectionEnd;

    if (posBegin != null && posEnd != null)
    {
      let strBegin = currentControl.value.substring(0, posBegin),
          strEnd = currentControl.value.substring(posEnd, currentControl.value.length);

      currentControl.value = strBegin + sMacros + strEnd;
      currentControl.selectionStart = posBegin + sMacros.length;
      currentControl.selectionEnd = currentControl.selectionStart;
    }
  }


  function close ()
  {
    if (pDialog)
    {
      pDialog.closeWindow();
      pDialog = null;
    }

    if (currentControl)
    {
      currentControl.focus();
    }

    if (BEditor.browser.isIE)
    {
      restoreRange();
    }
  }


  function getCurrentSelection ()
  {
    try
    {
      return (BEditor.browser.isIE) ? currentWindow.document.selection : currentWindow.getSelection();
    }
    catch (err)
    {
      return null;
    }
  }


  function getCurrentRange ()
  {
    let selectedRange,
        defaultRange,
        selection = getCurrentSelection();

    if (selection)
    {
      if (BEditor.browser.isIE)
      {
        selectedRange = (selection) ? selection.createRange() : null;
        return selectedRange;
      }
      else
      {
        if (selection.rangeCount > 0)
        {
          selectedRange = selection.getRangeAt(0);
          return selectedRange.cloneRange();
        }
        else
        {
          selection.removeAllRanges();
          defaultRange = currentWindow.document.createRange();
          defaultRange.setStart(currentWindow.document.body, 0);
          defaultRange.setEnd(currentWindow.document.body, 0);
          selection.addRange(defaultRange);
          return defaultRange;
        }
      }
    }
    else
    {
      try
      {
        defaultRange = currentWindow.document.createRange();
        defaultRange.setStart(currentWindow.document.body, 0);
        defaultRange.setEnd(currentWindow.document.body, 0);
        selection = currentWindow.getSelection();

        if (selection)
        {
          selection.removeAllRanges();
          selection.addRange(defaultRange);
        }
      }
      catch (err)
      {
        return null;
      }

      return defaultRange;
    }
  }


  function saveRange()
  {
    if (!isSaveCurrentRange)
    {
      isSaveCurrentRange = true;
      saveCurrentRange = getCurrentRange();
    }
  }


  function restoreRange()
  {
    if (saveCurrentRange)
    {
      try
      {
        if (BEditor.browser.isIE)
        {
          saveCurrentRange.select();
        }
        else
        {
          let selection = currentWindow.getSelection();
          selection.removeAllRanges();
          selection.addRange(saveCurrentRange);
        }
      }
      catch (err)
      {
        saveCurrentRange = null;
        isSaveCurrentRange = false;
      }

      isSaveCurrentRange = false;
    }
  }

}